/**
 * Ryan O'Dowd
 * 2024-12-04
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({windowWidth, windowHeight}) => {
  return {
    container: {
      position: 'absolute',
      top: 0,
      left: 0,
      flex: 1,
      width: windowWidth,
      height: windowHeight,
      alignItems: 'center',
      justifyContent: 'center',
    },
    backgroundImageWrapper: {
      position: 'absolute',
      top: 0,
      left: 0,
      flex: 1,
    },
    snow: {
      width: windowWidth,
      height: windowHeight,
      opacity: 0.4,
    },
  };
};

export default getStyles;
